import "../assets/styles/Agreement.css";
import { useEffect, useState } from "react";
import printImage from "../assets/images/print.svg";
// import downArrow from "../assets/images/down-arrow.png";
// import signaturePen from "../assets/images/signature-pen.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import SignatureCanvas from "react-signature-canvas";
// import JsPDF from "jspdf";

export default function Agreement() {
  useEffect(() => {
    setTimeout(function () {
      if (location.state == null) {
        if (localStorage.getItem("isTrial") === "true") {
          navigate("/trial-user");
        } else if (localStorage.getItem("isTrial") === "false") {
          navigate("/subscribed-user");
        }
      } else {
        if (localStorage.getItem("dontShowAgree") === "true") {
          navigate("/PurchaseSuccess", {
            state: {
              showSuccessModal: true,
              assessmentLeft: location.state.availableBalance,
              expiryDate: location.state.expiryDate,
              totalAssessments: location.state.totalAssessments,
            },
          });
        }
      }
    }, 0);
  }, []);

  const [modal, setModal] = useState(false);
  const [sign, setSign] = useState();
  const [signUrl, setSignUrl] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const Print = () => {
    window.print();
  };
  const toggleModal = () => {
    setModal(!modal);
  };
  const handleClear = () => {
    sign.clear();
    setSignUrl("");
  };
  const handleGenerate = () => {
    setSignUrl(sign.getTrimmedCanvas().toDataURL("image/png"));
    setModal(!modal);
  };
  const goToPurchaseSucess = () => {
    setTimeout(function () {
      localStorage.setItem("dontShowAgree", true);
      navigate("/PurchaseSuccess", {
        state: {
          showSuccessModal: true,
          assessmentLeft: location.state.availableBalance,
          expiryDate: location.state.expiryDate,
          totalAssessments: location.state.totalAssessments,
        },
      });
    }, 0);
  };

  return (
    <div className="Agreement" id="report">
      <Modal isOpen={modal} toggle={toggleModal} className="Agreement-modal">
        <ModalHeader toggle={toggleModal} className="Agreement-modal-header">
          Please Sign here
        </ModalHeader>
        <ModalBody>
          <div className="Agreement-modal-body">
            <div style={{ border: "2px solid black" }}>
              <SignatureCanvas
                canvasProps={{
                  width: 460,
                  height: 200,
                  className: "sigCanvas",
                }}
                ref={(data) => setSign(data)}
              />
            </div>
            <div className="Agreement-modal-body-btns">
              <button
                onClick={handleClear}
                className="Agreement-modal-body-btns-clear"
              >
                Clear
              </button>
              <button
                onClick={handleGenerate}
                className="Agreement-modal-body-btns-save"
              >
                Save
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <div className="Agreement-box">
        <span className="Agreement-box-head">Agreement</span>
        <span className="Agreement-box-termsConditionText">
          This Agreement is entered into on the{" "}
          <b>
            {new Date().toLocaleString("en-US", { day: "2-digit" })},{' '}
            {new Date().toLocaleString("en-US", { month: "long" })}{" "}
            {new Date().getFullYear()}
          </b>{" "}
          Between
        </span>
        <span className="Agreement-box-termsConditionText">
          <b>{localStorage.getItem("userName")}</b> of{" "}
          <b>{localStorage.getItem("clinicName")}</b> clinic located at{" "}
          <b>{localStorage.getItem("address")}</b>
        </span>
        <span className="Agreement-box-termsConditionText">And</span>
        <span className="Agreement-box-termsConditionText">
          <b>Salcit Technologies Private Limited</b>, India (represented by
          Zensark Technologies Private Limited, Salcit's sole authorized
          representative and reseller and development partner) with its
          registered office at S No. 43/6, Plot No. 65, Flat No. 7 Mrunmayee
          Co-op Society, Shangri-La Galli, Erandwane, Pune-411 001, Maharashtra,
          India.
        </span>
        <span className="Agreement-box-termsConditionText">
          Whereas this Agreement covers the broad relationship and understanding
          that both <b>{localStorage.getItem("clinicName")}</b> and Salcit will
          mutually extend to each other and will cover the below-mentioned areas:
        </span>
        <span className="Agreement-box-termsConditionText">
          <ul>
            <li type="1">
              Salcit will provide Swaasa® Software as a Service offering, and
              related services, on the terms of the Agreement.
            </li>
            <li type="1">
              <span>The initial collaborative efforts are focused on:</span>
              <ul>
                <li>
                  Demo & Training and for OPD clinic staff on the Swaasa®
                  application.
                </li>
                <li>
                  Subscription Fee of{" "}
                  <span style={{ fontFamily: "math" }}>₹</span>3350/- is valid
                  for a period of 1 Year from the date of subscription.
                </li>
                <li>
                  Usage of Swaasa® subscription is for 50 assessments of the
                  Swaasa Core product variant.
                </li>
              </ul>
            </li>
            <li type="1">
              <span>General Terms & Assumptions:</span>
              <ul>
                <li>
                  Salcit Technologies is not providing any equipment such as
                  phones or tablets.
                </li>
                <li>
                  <b>{localStorage.getItem("clinicName")}</b> will be using it
                  in his/her OPD and will share the results and observations
                  with Salcit Technologies.
                </li>
                <li>
                  The Swaasa® solution is to be used only for adults, meaning
                  above 18 years of age.
                </li>
                <li>
                  Additional blocks of assessments may be
                  separately purchased as an addendum to this Agreement.
                </li>
              </ul>
            </li>
            <li type="1">
              Confidentiality - The parties agree to keep this Agreement and its
              terms confidential.
            </li>
          </ul>
        </span>
        <span className="Agreement-box-termsConditionText">
          <b>Signatures</b>
        </span>
        <span className="Agreement-box__signatures">
          <span className="Agreement-box__signatures__signature-head">
            <span className="Agreement-box-termsConditionText">
              For<b> Salcit Technologies Private Limited</b>
            </span>
            <span className="Agreement-box__signatures__signature-left">
              <span>
                <span>Narayana Rao Sripada</span>
                {/* <span style={{ marginLeft: "-182px" }}>
                  __________________
                </span> */}
              </span>
              <span>Signature</span>
            </span>
            <span className="Agreement-box-termsConditionText">
              <b>Name: </b> Narayana Rao Sripada
            </span>
            <span className="Agreement-box__signatures__role">
              <b>Role: </b>CTO & Founder
            </span>
            <span className="Agreement-box-termsConditionText">
              <b>Date: </b>{" "}
              <span>
                {new Date().toLocaleString("en-US", { day: "2-digit" })}{" "}
                {new Date().toLocaleString("en-US", { month: "long" })}{" "}
                {new Date().getFullYear()}
              </span>
            </span>
          </span>
          <span className="Agreement-box__signatures__signature-head" >
            <span className="Agreement-box-termsConditionText">
              For<b> {localStorage.getItem("clinicName")}</b>
            </span>
            <span className="Agreement-box__signatures__signature-right" style={{minWidth:'200px',maxWidth:'400px'}}>
              <span className="main-sign-field">
                <span>
                  {signUrl ? (
                    <img
                      style={{ width: "100px", height: "40px" }}
                      src={signUrl}
                      alt='sign'
                    />
                  ) : (
                    ""
                  )}
                  {signUrl ? (
                    <span style={{ marginLeft: "-105px" }}>
                      ________________
                    </span>
                  ) : (
                    <span>_________________</span>
                  )}
                </span>
                <span
                  onClick={toggleModal}
                  className="click-here-to-sign-btn no-printme"

                >
                  Click here to sign
                </span>
              </span>
              <p style={{marginTop:'-5px'}}>Signature</p>
            </span>
            <span className="Agreement-box-termsConditionText" style={{marginTop:'20px'}}>
              <b>Name: </b> {localStorage.getItem("userName")}
            </span>
            <span className="Agreement-box__signatures__role">
              <b>Role: </b>
              {localStorage.getItem("role")}
            </span>
            <span className="Agreement-box-termsConditionText">
              <b>Date: </b>{" "}
              <span>
                {new Date().toLocaleString("en-US", { day: "2-digit" })}{" "}
                {new Date().toLocaleString("en-US", { month: "long" })}{" "}
                {new Date().getFullYear()}
              </span>
            </span>
          </span>
        </span>
      </div>
      <div className="Agreement-btns no-printme">
        <span className="Agreement-btns-printBtn" onClick={Print}>
          <img src={printImage} alt='print'></img>
          <span>Print/ Save</span>
        </span>
        {signUrl ? (
          <span className="Agreement-btns-doneBtn" onClick={goToPurchaseSucess}>
            Done
          </span>
        ) : (
          <span className="Agreement-btns-doneBtn-disbled">Done</span>
        )}
      </div>
    </div>
  );
}
